export const LOAD_ESCALATION = 'LOAD_ESCALATION';
export const SAVE_ESCALATION = 'SAVE_ESCALATION';
export const SUBMIT_ESCALATION = 'SUBMIT_ESCALATION';
export const LOAD_ESCALATION_META = 'LOAD_ESCALATION_META';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';